import { ChartType } from "src/lib/client/useMovieChart";

const getMovieChartText = (chartType: ChartType) => {
	let chartTypeText: string = "";

	if (chartType === "week") chartTypeText = "uke";
	if (chartType === "weekend") chartTypeText = "helg";
	if (chartType === "year") chartTypeText = "år";
	if (chartType === "opening") chartTypeText = "åpningshelg";

	return chartTypeText;
}

export { getMovieChartText };